import { createSlice, createAsyncThunk, createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

export const fetchCategoriesCards = createAsyncThunk(
  '/categories/fetchCards',
  async (_, { getState }) => {
    const state = getState().categories;
    const { data } = await axios.get(`/market`, {
      params: {
        status: state.filter.status,
        size_to: state.filter.size === '0' ? null : state.filter.size,
        price_to: state.filter.price === '0' ? null : state.filter.price,
        cathegory: state.filter.cathegory,
        limit: 42,
        page: state.currentPage,
        subcathegory: state.filter.subcathegory,
      },
    });

    return data;
  }
);

const initialState = {
    subcathegories: [],
    cards: [],
    status: 'loading',
    scrollPosition: null,
    pages: 1,
    currentPage: 1,
    limit: 4,
    filter: {
        cathegory: 'teddy',
        status: null,
        size: '0',
        price: '0',
    }
}

const categoriesSlice = createSlice({
    name: 'categories',
    initialState,
    reducers: {
        saveScrollPosition: (state, action) => {
            state.scrollPosition = action.payload;
        },
        setFilter: (state, action) => {
            state.filter = action.payload;
            state.currentPage = 1;
        },
        setPageSize: (state, action) => {
            state.limit = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
    },
    extraReducers: {
        [fetchCategoriesCards.pending] : (state) => {
            state.status = 'loading';
        },
        
        [fetchCategoriesCards.fulfilled] : (state, action) => {
            state.cards = action.payload.items;
            state.pages = action.payload.pages;
            state.subcathegories = action.payload.subcathegories || [];
            state.status = 'loaded';
        },
    },
});

export const {
    setFilter,
    saveScrollPosition,
    setPageSize, setCurrentPage,
} = categoriesSlice.actions;

export const categoriesListenerMiddleware = createListenerMiddleware();

const fetchCategoriesCardsEffect = async (_, { dispatch }) => {
    dispatch(fetchCategoriesCards());
}
categoriesListenerMiddleware.startListening({
    matcher: isAnyOf(setCurrentPage, setFilter),
    effect: fetchCategoriesCardsEffect
})

export const categoriesStatusSelect = (state) => state.categories.status;
export const categoriesCardsSelect = (state) => state.categories.cards;
export const categoriesFilterSelect = (state) => state.categories.filter;
export const subCategoriesFilterSelect = (state) => state.categories.subcathegories;
export const categoriesPagingSelect = (state) => ({
    pages: state.categories.pages,
    currentPage: state.categories.currentPage
});
export const categoriesReducer = categoriesSlice.reducer;
